import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-partial-stock',
  templateUrl: './partial-stock.component.html',
  styleUrls: ['./partial-stock.component.scss']
})
export class PartialStockComponent implements OnInit {

  @Input() data: any;
  availability: any;

  constructor() {
    //Empty Constructor
   }

  ngOnInit() {
    if (this.data && this.data.label !== 'IN') {
      this.availability = this.data.availability;
    }
  }

  getDate(date: string){
    return date.slice(0,4) + '-' + date.slice(4,6) + '-' + date.slice(6,8);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bom-table/partial-stock/partial-stock.component.ts